import React, { useEffect } from 'react';
import { TextInput } from '@/components/forms/base/TextInput';
import { TbBuilding, TbPlus, TbUser, TbX } from 'react-icons/tb';
import SuppliersInput from '@/components/forms/base/SuppliersInput/SuppliersInput';
import { useFormContext } from 'react-hook-form';
import { Button } from '@/components/molecules/Button';

interface DeclarationDynamicFormProps {
  showRepresentativeRestaurantAddress?: boolean;
  showRestaurantNameAddress?: boolean;
}
export const DeclarationDynamicForm = ({ showRepresentativeRestaurantAddress = true, showRestaurantNameAddress = true }: DeclarationDynamicFormProps) => {
  const { watch, setValue } = useFormContext();

  const suppliers = watch('suppliers') || [];

  useEffect(() => {
    if (suppliers.length === 0) {
      setValue('suppliers', [''], { shouldValidate: true, shouldDirty: true });
    }
  }, [suppliers, setValue]);

  const addSupplier = () => {
    if (suppliers.length < 6) {
      setValue('suppliers', [...suppliers, ''], { shouldValidate: true, shouldDirty: true });
    }
  };

  const removeSupplier = (index: number) => {
    const updatedSuppliers = suppliers.filter((_: string, i: number) => i !== index);
    setValue('suppliers', updatedSuppliers.length > 0 ? updatedSuppliers : [''], {
      shouldValidate: true,
      shouldDirty: true
    });
  };
  return (
    <div className="md:border rounded-xl md:p-6">
      <h2 className="font-bold text-xl mb-4">Formulaire de Déclaration</h2>
      <div className="flex flex-col gap-2 w-full p-5 xl:p-0">
        {showRepresentativeRestaurantAddress && (
          <>
            <div className="flex gap-5">
              <TextInput id="firstName" leftIcon={<TbUser />} maxLength={20} label="Prénom" />
              <TextInput id="lastName" leftIcon={<TbUser />} maxLength={20} label="Nom" />
            </div>
            {showRestaurantNameAddress && (
              <>
                <TextInput id="restaurantName" maxLength={50} label="Restaurant" disabled />
                <TextInput id="address" maxLength={50} label="Adresse" disabled />
              </>
            )}
          </>
        )}
        <TextInput id="company" leftIcon={<TbBuilding />} required maxLength={50} label="Société" />
        <div>
          <span className="flex flex-col mb-2">
            <div className="flex items-center gap-2">
              <h3 className="text-base text-slate-700">Liste complète de vos fournisseurs</h3>
              <div className="bg-red-500 h-2.5 w-1 rounded-[20px]" />
            </div>
            <h3 className="font-light text-xs text-slate-600">(Marque + organisme certificateur)</h3>
          </span>

          {suppliers.map((_: string, index: number) => (
            <div className="flex gap-2 relative w-full" key={index}>
              <SuppliersInput index={index} id={`supplier-${index}`} horizontal={false} required={true} />
              {suppliers.length > 1 && (
                <button
                  type="button"
                  className="bg-red-500 text-white w-fit h-fit p-2 rounded-lg bottom-2 absolute right-20"
                  onClick={() => removeSupplier(index)}
                >
                  <TbX />
                </button>
              )}
            </div>
          ))}

          <Button type="button" color="success" onClick={addSupplier} icon={<TbPlus />} label="Ajouter un fournisseur" disabled={suppliers.length >= 6} />
        </div>
      </div>
    </div>
  );
};
